import React, {createContext, useContext, useState} from "react";
import siderepository from "../../repository/AdminDashboard/sidebar-repository";
import toast, {Toaster} from "react-hot-toast";
import {siteUrl} from "../../clases/constans";

const StateContext = createContext();

const initialState = {
    user: undefined,
};

const MainContext = ({children}) => {
    const [user, setUser] = useState([]);
    const [isPageLoaded, setisPageLoaded] = useState(false);
    const [showprofile, setshowprofile] = useState(false);
    const [modal, setmodal] = useState({name: "", number: "", password: ""});
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [showlogout, setshowlogout] = useState(false);
    const [res, setres] = useState(false);
    const [cod, setcod] = useState("");

    // Show submenu on mouse enter
    const handleMouseEnter = (event) => {
        event.currentTarget
            .getElementsByTagName("ul")[0]
            .classList.remove("hidden");
    };

// Hide submenu on mouse leave
    const handleMouseLeave = (event) => {

        event.currentTarget.getElementsByTagName("ul")[0].classList.add("hidden");
    };

    // Fetch user data from the sidebar
    const getSidebar = async () => {
        const data = await siderepository.getusername();
        setcod(data.code);
        setIsApiCalled(true);

        if (data.code === 1) {
            setUser(data.user);
            setmodal(data.user);
            setisPageLoaded(true);
            return {
                status: 1,
            };
        } else if (data.code === 0) {
            toast.error(data.message, {
                className: "text-12 text-dark-blue-200",
            });
            return {
                status: 0,
            };
        }

    };

    // Open user profile
    const profile = () => {
        setshowprofile(true);
    };

    // Close user profile
    const closeprofile = () => {
        setshowprofile(false);
    };

    // Edit user profile
    const getedit = async (data_) => {
        try {
            const data = await siderepository.edit(data_);
            if (data.code == 1) {
                setshowprofile(false);
                setTimeout(() => {
                    toast.success(data.massage, {
                        className: "text-12 text-dark-blue-200",
                    });
                }, 4000);
                await getSidebar();
            } else if (data.code == 0) {
                return toast.error(data.massage, {
                    className: "text-12 text-dark-blue-200",
                });
            }
        } catch (error) {
            console.error("خطا در اتصال به سرور", error);
            return {status: 0};
        }
    };

    //  get logout
    const getLogout = async (token) => {
        try {
            await siderepository.LogOut(token);
            localStorage.clear();
            window.location.href='/';
        } catch (error) {
            console.error("خطا در اتصال به سرور", error);
            return {status: 0};
        }
    }

    // Handle change in input fields
    const onchangeInput = (event) => {
        const {id, value} = event.target;

        switch (id) {
            case "name":
                setmodal((prevModal) => ({...prevModal, name: value}));
                break;
            case "number":
                const trimmedValue = value.trim();
                const formattedNumber = "+98" + trimmedValue.slice(1);
                setmodal((prevModal) => ({...prevModal, number: trimmedValue}));
                break;
            case "password":
                setmodal((prevModal) => ({...prevModal, password: value}));
                break;
            default:
                break;
        }
    };


    // Save changes to user profile
    const profilebtn = async () => {
        if (modal.name.length === 0) {
            toast.error("نام خود را وارد کنید", {
                className: "text-12 text-dark-blue-200",
            });
        } else if (modal.number.length === 0) {
            toast.error("شماره خود را وارد کنید", {
                className: "text-12 text-dark-blue-200",
            });
        } else {
            const y = "+98" + modal.number.slice(1);
            const role = localStorage.getItem("role");
            let data;

            if (role === "admin") {
                data = {
                    name: modal.name,
                    number: y,
                    password: modal.password,
                };
            } else if (role === "user") {
                data = {
                    name: modal.name,
                    number: y,
                };
            }

            await getedit(data);
        }
    };

    // Logout user
    const logout = async () => {
        const token = localStorage.getItem("token");
        await getLogout(token);
    };

    // Show logout modal
    const logoutmodal = () => {
        setshowlogout(true);
    };

    // Close logout modal
    const closelogout = () => {
        setshowlogout(false);
    };
    return (
        <StateContext.Provider
            value={{
                user,
                handleMouseLeave,
                handleMouseEnter,
                isPageLoaded,
                profile,
                showprofile,
                closeprofile,
                onchangeInput,
                profilebtn,
                getSidebar,
                logout,
                setisPageLoaded,
                isApiCalled,
                showlogout,
                closelogout,
                logoutmodal,
                res,
                cod,
            }}>
            {children}
        </StateContext.Provider>
    );
};

// Custom hook to use MainContext
function useStateContext() {
    return React.useContext(StateContext);
}

// Export the hook and MainContext
export {useStateContext};
export default MainContext;
